import { PerformanceRating } from '@entities/enums/performance-rating';

export const getAggregateRating = (
   entities: Array<{ rating?: PerformanceRating }>
): PerformanceRating => {
   const ratings = entities.map((entity) => entity.rating ?? PerformanceRating['No Value']);
   if (ratings.every((rating) => rating === PerformanceRating.Strength)) {
      return PerformanceRating.Strength;
   } else if (ratings.some((rating) => rating === PerformanceRating.Weakness)) {
      return PerformanceRating.Weakness;
   } else if (ratings.every((rating) => rating === PerformanceRating['No Value'])) {
      return PerformanceRating['No Value'];
   } else {
      return PerformanceRating['Needs Improvement'];
   }
};
